import { SubscriptionModule } from "@/constants/workplaces.ts";

export enum WidgetType {
  CLOUD_SECURITY = SubscriptionModule.CLOUD_SECURITY,
  ENDPOINT_SECURITY = SubscriptionModule.ENDPOINT_SECURITY,
  EMAIL_SECURITY = SubscriptionModule.EMAIL_SECURITY,
  USER_DATA_GOVERNANCE = SubscriptionModule.USER_DATA_GOVERNANCE,
  ENDPOINT_DATA_GOVERNANCE = SubscriptionModule.ENDPOINT_DATA_GOVERNANCE,
  EDR = SubscriptionModule.EDR,
  SECURITY_AWARENESS_TRAINING = SubscriptionModule.SECURITY_AWARENESS_TRAINING,
  BACKUP_AND_RESTORE = SubscriptionModule.BACKUP_AND_RESTORE,
}

export enum AdditionalWidgetType {
  OPEN_TICKETS_SUMMARY = "openTicketsSummary",
}

export enum OverviewCardWidgetType {
  PROTECTED_USERS = "protectedUsersOverview",
  PROTECTED_DEVICES = "protectedDevicesOverview",
  OPEN_TICKETS = "openTicketsOverview",
  AUTO_RESOLVED_TICKETS = "autoResolvedTicketsOverview",
}

export enum SecurityCoverageWidgetType {
  WORKSPACE_HEALTH = "workspaceHealthWidget",
  SUBSCRIPTION_OVERVIEW = "subscriptionOverviewWidget",
  SECURITY_GAPS_WIDGET = "securityGapsWidget",
}
